module.exports = __webpack_public_path__ + "static/media/truck.c8733026.svg";